namespace appn.views.folders.createOrEdit {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Toggle show/hide of restrict fields
        $('#Folder_IsRestricted').change(function() {
            if ($('#Folder_IsRestricted').prop('checked'))
                $('.folder-restricted-msg').removeClass('d-none');
            else
                $('.folder-restricted-msg').removeClass('d-none').addClass('d-none');

            setSize();
        });
    }

    function setSize() {
        const selfHeight = $('body').outerHeight();
        if ($('#Folder_IsRestricted').prop('checked')) {
            appn.iframe.setModalIframeHeight();
            $('.lockIndicator').css('opacity', 1);
        } else {
            appn.iframe.setModalIframeHeight();
            $('.lockIndicator').css('opacity', 0.3);
        }
    }
}
